<template>
  <nav
    class="fixed top-0 sm:bottom-0 left-0 z-[60] flex flex-col justify-between flex-none w-full min-h-[100dvh] bg-white sidebar border-slate-200 dark:border-zinc-700 dark:bg-zinc-900"
    :class="sidebarClasses"
  >
    <div>
      <Logo
        class="inline-block mx-3.5 mt-4 rounded focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none dark:text-white"
        :icon="isExpanded ? 'general.logoWithText' : 'general.logo'"
        :src="orgCustomLogoUrl"
        :href="logoRedirectUrl"
        @click="logoClick"
      />
    </div>
    <div class="flex items-center justify-between m-6 gap-x-1 gap-y-2" :class="isExpanded ? '' : 'flex-col-reverse'">
      <DarkMode />
    </div>
  </nav>

  <Logo
    class="absolute top-0 left-0 inline-block mx-3.5 mt-4 rounded focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none dark:text-white sm:hidden"
    icon="general.logoWithText"
    :src="orgCustomLogoUrl"
    :href="logoRedirectUrl"
    @click="logoClick"
  />
</template>

<script setup lang="ts">
import { onBeforeMount, computed } from 'vue';
import { storeToRefs } from 'pinia';

import { useLayoutStore } from '@/store/useLayoutStore';

import DarkMode from '@/components/DarkMode.vue';
import Logo from './Logo.vue';

import { useMobileDetection } from '@/composables/useMobileDetection';
import { TrackEvents, useTrack } from '@/composables/useTrack';

import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const { track } = useTrack();

const layoutStore = useLayoutStore();
const { isSidebarExpanded: isExpanded } = storeToRefs(layoutStore);

const { id, orgRedirectLogoUrl, orgCustomLogoUrl, hideBranding } = storeToRefs(useViewerItemStore());

const { isMobile } = useMobileDetection();

const logoClick = () => track(TrackEvents.LOGO_CLICK, { viewer: 'copernicus', hashid: id?.value });
const logoRedirectUrl = computed(() => (orgCustomLogoUrl.value && orgRedirectLogoUrl.value ? orgRedirectLogoUrl.value : 'https://www.zight.com'));

const sidebarClasses = computed(() => {
  if (isExpanded.value) {
    return isMobile.value ? 'flex' : 'sm:w-16';
  }

  return isMobile.value ? 'hidden sm:flex' : 'sm:w-16 overflow-x-visible';
});

onBeforeMount(() => {
  if (isMobile.value || hideBranding.value) {
    layoutStore.hideSidebar();
  }
});
</script>
